import { Order } from "@/types";
import { useState, useEffect } from "react";
import ServicePageHeader from "./page-header";
import { fetchOrders } from "@/server/api-services";
import PaymentListTable from "@/app/shared/payments/list/table";

export default function PaymentsListPage() {
    const [payments, setPayments] = useState([] as Order[]);

    useEffect(() => {
        loadPayments();
    }, []);

    async function loadPayments() {
        const response = await fetchOrders();

        

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Order[];

        setPayments(data);
    }

    const refresh = () => loadPayments();

    return (
        <>
            <ServicePageHeader title="Payments" hideButton={false} />
            <PaymentListTable
                orders={payments}
                refresh={refresh}
            />
        </>
    );
}
